module.exports = __webpack_public_path__ + "static/bbc-967905e4fd48cea2155e3c49630ba119.png";